import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(0, 4, 5),
    },
    label: {
      marginBottom: theme.spacing(3),
    },
    buttonsWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
    },
    button: {
      width: 210,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1.5, 2),
      border: theme.shape.borderGray70,
      boxShadow: theme.shape.boxShadowNormal,
      justifyContent: 'flex-start',
      columnGap: theme.spacing(1.5),
      '&:hover': {
        boxShadow: theme.shape.boxShadowLarge,
      },
      '&:active': {
        boxShadow: 'unset',
        borderColor: COLORS.primary.default,
      },
    },
    icon: {
      fontSize: theme.typography.pxToRem(20),
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'Select' }
);
